import Service from '../auth_services';
import NotMerchantError from '../../Common/exceptions/NotMerchantError';
import PasswordResetNotDoneError from '../../Common/exceptions/PasswordResetNotDoneError';

export default {
  /**
   * @param context
   * @param data
   */
  async login({ commit }, data) {
    const response = await Service.login(data);

    if (!response.user.isMerchant) {
      throw new NotMerchantError('User is not a merchant.');
    }
    if (!response.user.password_change) {
      throw new PasswordResetNotDoneError('Password reset is needed.');
    }

    commit('setProperty', { property: 'user', payload: response.user });
    commit('setProperty', { property: 'token', payload: response.token });

    localStorage.setItem('jwt_token', response.token.token);
    localStorage.setItem('jwt_refresh_token', response.token.refreshToken);

    const merchant = await Service.merchant();
    commit('setProperty', { property: 'merchant', payload: merchant });

    return response;
  },

  /**
   *
   * @param context
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  async forgotPassword(context, data) {
    // eslint-disable-next-line no-return-await
    return await Service.forgotPassword(data);
  },

  /**
   *
   * @param context
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  async passwordReset(context, data) {
    // eslint-disable-next-line no-return-await
    return await Service.passwordReset(data);
  },

  /**
   *
   * @param commit
   * @param data
   * @returns {Promise}
   */
  async updatePassword({ commit }, data) {
    const response = await Service.merchantPasswordChange(data);

    commit('setProperty', { property: 'user', payload: response.user });
    commit('setProperty', { property: 'token', payload: response.token });

    localStorage.setItem('jwt_token', response.token.token);
    localStorage.setItem('jwt_refresh_token', response.token.refreshToken);

    return response;
  },


  /**
   *
   * @param context
   * @returns {Promise<AxiosResponse<T>>}
   */
  async logout(context) {
    // eslint-disable-next-line no-return-await
    const response = await Service.logout();

    localStorage.removeItem(process.env.VUE_APP_LS_KEY);
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('jwt_refresh_token');
    localStorage.removeItem('merchant-admin-dashboard');

    return response;
  },
};
